import _ from 'lodash';

export default function SelecaoSistemaController(
  $q,
  $state,
  acessoService,
  promiseTracker,
  entidadeContextoHolder
) {
  const vm = this;
  vm.trackers = { carregando: promiseTracker() };

  (() => {
    const contextoAtual = entidadeContextoHolder.get();
    const promise = acessoService.getSistemasByEntidade(contextoAtual.values.entity)
      .then((sistemas) => {
        if (_.isEmpty(sistemas)) {
          $state.go('main.entidade');
          return $q.defer().promise;
        }

        vm.sistemas = sistemas;
      });

    vm.trackers.carregando.addPromise(promise);
    return promise;
  })();

  vm.selecionar = (sistema) => {
    const contextoAtual = entidadeContextoHolder.get();
    const params = {
      APP_SYSTEM: sistema.id
    };

    const goPromise = sistema.urlSubcontext
      ? abrirSistemaComSubcontexto(sistema, contextoAtual, params)
      : $state.go('main.entidade.selected.sistema.selected.visaoGeralSistema', params);

    vm.trackers.carregando.addPromise(goPromise);
    return goPromise;
  };

  function abrirSistemaComSubcontexto(sistema, contextoAtual, params) {
    return acessoService.getAcessoPrincipal(sistema.id, contextoAtual.values.entity)
      .then((acessoPrincipal) => {
        const state = acessoPrincipal
          ? 'main.entidade.selected.sistema.selected.visaoGeralSistema'
          : 'main.entidade.selected.sistema.selected.subcontexto';

        return $state.go(state, params);
      });
  }
}

SelecaoSistemaController.$inject = [
  '$q',
  '$state',
  'AcessoService',
  'promiseTracker',
  'EntidadeContextoHolderService',
];
